import { render, staticRenderFns } from "./I18n.vue?vue&type=template&id=526bd486&"
import script from "./I18n.vue?vue&type=script&lang=js&"
export * from "./I18n.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports